var exports = {
  "k": "x127c5a35--048268--container",
};

module.exports = exports;
